import React, { useState ,useEffect} from "react";
import { Card  , Modal, Row, Col} from 'react-bootstrap';
import { Link ,useParams} from 'react-router-dom';
import taleimg1 from '../../../assets/img/taleimg1.jpg'
import userimg1 from '../../../assets/img/User1.jpg'
import userimg2 from '../../../assets/img/User4.jpg'
import userimg3 from '../../../assets/img/user5.jpg'
import userimg4 from '../../../assets/img/User3.jpg'
import userlike1 from '../../../assets/img/avatars/2.png'
import userlike2 from '../../../assets/img/avatars/4.png'
import userlike3 from '../../../assets/img/avatars/6.png'
import userlike4 from '../../../assets/img/avatars/8.png'
import userlike5 from '../../../assets/img/avatars/10.png'
import { getTaleDetail } from '../../../api/taleService';
export default function ViewAIGeneratedtale() {
  const [show, setShow] = useState(false);
  const [comment, setComment] = useState(false);
  const [like, setLike] = useState(false);
  const [tale, setTale] = useState({});
  const [likesCount, setLikesCount] = useState(0);
  const [commentsCount, setCommentsCount] = useState(0);
  const [likes, setLikes] = useState([]);
  const [comments, setComments] = useState([]);

  const videotoggle = () => setShow(!show);
  const commentToggle = () => setComment(!comment);
  const likeToggle = () => setLike(!like);

  const { taleId } = useParams();
  
  useEffect(() => {
    if (taleId) {
      fetchTales(taleId);
    }
  }, [taleId]);

  const fetchTales = (taleId) => {
    getTaleDetail(taleId)
    .then((response) => {
      if (response.data && response.data.data) {
        const { taleDetail, likesCount, commentsCount, likes, comments } = response.data.data;
        setTale(taleDetail);
        setLikesCount(likesCount);
        setCommentsCount(commentsCount);
        setLikes(likes);
        setComments(comments);
      }
    })
    .catch((error) => console.error("Error fetching tale details", error));
  };

  const Talelikedata = [
    {
      id: 1,
      imgurl: userlike1,
      name: 'April Curtis',
    },
    {
      id: 2,
      imgurl: userlike2,
      name: 'Templeton Peck',
    },
    {
      id: 3,
      imgurl: userlike3,
      name: 'Angus MacGyver',
    },
    {
      id: 4,
      imgurl: userlike4,
      name: 'Rick Wright',
    },
    {
      id: 5,
      imgurl: userlike5,
      name: 'Mike Torello',
    },
    {
      id: 6,
      imgurl: userlike1,
      name: 'Templeton Peck',
    },
    {
      id: 7,
      imgurl: userlike2,
      name: 'Angus MacGyver',
    },
];

return

  return (
    <React.Fragment>
      <Card>
        <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
          <h5>AI-Generated Tale Details</h5>
          <Link className="btn btn-primary-light d-inline-flex align-items-center justify-content-center px-4 min_width140" to="/ai-generated-tales">Back</Link>
        </Card.Header>
        <Card.Body className="taledtl_div mt-3">
          <Row>
            <Col md="4">
              <div className="talefile_box">
                <img onClick={videotoggle} className="talefile_img" src={taleimg1} alt="" />
              </div>
            </Col>
            <Col md="8">
              <div className="talefile_list">
                <div className="tablefilelist_grid">
                <h4>Title</h4>
                <p>{tale.title }</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Description</h4>
                  <p>{tale.description || "Loading..."}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Genre</h4>
                  <p>{tale.genre || "Loading..."}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Likes</h4>
                  <p><Link className="taledtl_like_btn" onClick={likeToggle}>{likesCount.toLocaleString()}</Link></p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Comments</h4>
                  <p><Link className="taledtl_like_btn" onClick={commentToggle}>{commentsCount.toLocaleString()}</Link></p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Username</h4>
                  <p>{tale.username || "Loading..."}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Character</h4>
                  <p>{tale.character || "Loading..."}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Status</h4>
                  <p><span className={`badge ${tale.status === "active" ? 'Active' : 'Inactive'}`}>{tale.status || "Loading..."}</span></p>
                </div>  
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Modal className="modal_likes" show={like} onHide={likeToggle} centered>
        <Modal.Header closeButton>
            <Modal.Title><h2 className="modalhead">Likes</h2></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="talelike_div">
            {Talelikedata.map((item) => (
              <div className="talelike_box">
                <img className="img-thumbnail" src={item.imgurl} alt="" />
                <h4>{item.name} </h4>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>  
      <Modal show={comment} size="lg" onHide={commentToggle} centered>
        <Modal.Header closeButton>
            <Modal.Title><h2 className="modalhead">Comments</h2></Modal.Title>
        </Modal.Header>
        <Modal.Body>
              <div className="talecomment_div">
                <div className="talecomment_box">
                  <img className="img-thumbnail" src={userimg2} alt="" />
                  <div className="talecomment_cont">
                    <h4 className="taleuser_name">Capt. Trunk</h4>
                    <p className="taleuser_msg">The portrayal of the sun's descent and burst of colors in the sky was truly magical. It convey the fleeting yet powerful beauty of a sunset on the beach.</p>
                    <p className="taleuser_time">4h ago</p>
                  </div>
                </div>
                <div className="talecomment_box">
                  <img className="img-thumbnail" src={userimg1} alt="" />
                  <div className="talecomment_cont">
                    <h4 className="taleuser_name">Rick Wright</h4>
                    <p className="taleuser_msg">The open-concept kitchen and living area is a game changer! The natural light flooding in really enhances the space. Smart!</p>
                    <p className="taleuser_time">4h ago</p>
                  </div>
                </div>
                <div className="talecomment_box ml_60">
                  <img className="img-thumbnail" src={userimg3} alt="" />
                  <div className="talecomment_cont">
                    <h4 className="taleuser_name">Sofia Merchant</h4>
                    <p className="taleuser_msg">The portrayal of the sun's descent and burst of colors in the sky was truly magic.</p>
                    <p className="taleuser_time">4h ago</p>
                  </div>
                </div>
                <div className="talecomment_box ml_60">
                  <img className="img-thumbnail" src={userimg4} alt="" />
                  <div className="talecomment_cont">
                    <h4 className="taleuser_name">John Doe</h4>
                    <p className="taleuser_msg">The portrayal of the sun's descent and burst of colors in the sky was truly magic.</p>
                    <p className="taleuser_time">4h ago</p>
                  </div>
                </div>
              </div>
        </Modal.Body>
      </Modal>   
      <Modal className="modal_video" show={show} onHide={videotoggle} centered>
        <Modal.Body>
          <iframe src="https://www.youtube.com/embed/D0UnqGm_miA?si=CZ49PDvs2j_dYMHE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </Modal.Body>
      </Modal>      
    </React.Fragment>
  );

}